export default {
	kanban: {
		Save: "Save",
		Close: "Close",
		Delete: "Delete",
		Name: "Name",
		Description: "Description",
		Type: "Type",
		"Start date": "Start date",
		"End date": "End date",

		Result: "Result",
		"No results": "No results",
		Search: "Search",
		"Search in": "Search in",
		"Add new row": "Add new row",
		"Add new column": "Add new column",
		"Add new card": "Add new card",
		"Edit card": "Edit card",
		Edit: "Edit",

		Everywhere: "Everywhere",
		Label: "Label",
		Status: "Status",
		Color: "Color",
		Date: "Date",
		Priority: "Priority",
		Progress: "Progress",

		Untitled: "Untitled",
		Rename: "Rename",
		"Move up": "Move up",
		"Move down": "Move down",
		"Move left": "Move left",
		"Move right": "Move right",
		Sort: "Sort",
		"Label (a-z)": "Label (a-z)",
		"Label (z-a)": "Label (z-a)",
		"Description (a-z)": "Description (a-z)",
		"Description (z-a)": "Description (z-a)",

		Duplicate: "Duplicate",
		"Duplicate of": "Duplicate of",
	},
};
